module.exports = __webpack_public_path__ + "r-v3/img/emoti-thumbs-up.db1e6e4c.svg";